// extracted by mini-css-extract-plugin
export var active = "style-module--active--ce0ec";
export var alien = "style-module--alien--e113e";
export var btnAgain = "style-module--btn-again--5d41d";
export var btnMinus = "style-module--btn-minus--9a04e";
export var btnPlus = "style-module--btn-plus--d8a9d";
export var btnReset = "style-module--btn-reset--587d8";
export var btnSettings = "style-module--btn-settings--76e1a";
export var btnStart = "style-module--btn-start--9b3f9";
export var btnWrap = "style-module--btn-wrap--9478e";
export var c = "style-module--c--c65ef";
export var center = "style-module--center--721fe";
export var descWrap = "style-module--desc-wrap--e5ceb";
export var directions = "style-module--directions--85ea6";
export var disabled = "style-module--disabled--2f8f9";
export var e = "style-module--e--67ab8";
export var eng = "style-module--eng--be19c";
export var fieldSize = "style-module--field-size--507bc";
export var ghost = "style-module--ghost--42ec0";
export var inputRadio = "style-module--input-radio--d64e8";
export var invisibleField = "style-module--invisible-field--a9240";
export var lang = "style-module--lang--1f522";
export var mainList = "style-module--main-list--17915";
export var objectsList = "style-module--objects-list--46eb4";
export var off = "style-module--off--554c6";
export var on = "style-module--on--340a9";
export var path = "style-module--path--1d0de";
export var portal = "style-module--portal--97447";
export var process = "style-module--process--a2527";
export var rocket = "style-module--rocket--3c5ef";
export var row = "style-module--row--3db05";
export var rus = "style-module--rus--14cbe";
export var sb = "style-module--sb--7f1d8";
export var settings = "style-module--settings--01f9b";
export var small = "style-module--small--a0d66";
export var speed = "style-module--speed--40d1c";
export var speedList = "style-module--speed-list--887e1";
export var steps = "style-module--steps--0038a";
export var subs = "style-module--subs--57af1";
export var toggleWrap = "style-module--toggle-wrap--eed62";
export var ufo = "style-module--ufo--6b5fb";